export const limitDefaultOptions = [10, 15, 25];
export const limitDefaultValue = limitDefaultOptions[0];
export const limitStorageName = 'itemsCount';
